/*
  Motureo: spis treści artykułu (W4, etap 8). Buduje listę odnośników z nagłówków H2 treści artykułu
  ([data-motureo-article-body]) i odsłania nawigację [data-motureo-toc], gdy nagłówków jest co najmniej dwa.
  Spis jest rozwijany (details): zwinięty na wąskim ekranie, żeby nie zasłaniał treści, rozwinięty od 1100 px.
  Nagłówek bez id dostaje id z tekstu (litery dowolnego alfabetu, np. cyrylica; znaki diakrytyczne zdejmowane
  tylko z łacinki, więc bułgarskie „й” zostaje „й”). Przewijanie płynne tylko
  bez prefers-reduced-motion; po przejściu fokus trafia na nagłówek (czytnik ekranu czyta, gdzie jesteśmy).
  Bez bibliotek; skrypt odroczony, nic nie blokuje renderowania.
*/
(() => {
  const nav = document.querySelector('[data-motureo-toc]');
  const body = document.querySelector('[data-motureo-article-body]');
  if (!nav || !body) return;

  const headings = Array.from(body.querySelectorAll('h2')).filter((h) => h.textContent.trim() !== '');
  if (headings.length < 2) return;

  const slug = (text) =>
    text
      .toLowerCase()
      .replace(/\p{Script=Latin}/gu, (c) => c.normalize('NFKD').replace(/\p{M}/gu, ''))
      .normalize('NFC')
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);

  const list = nav.querySelector('ol');
  headings.forEach((heading) => {
    if (!heading.id) {
      const base = slug(heading.textContent) || 'sekcja';
      let id = base;
      let n = 2;
      while (document.getElementById(id)) id = `${base}-${n++}`;
      heading.id = id;
    }
    heading.setAttribute('tabindex', '-1');
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });
  nav.hidden = false;

  const details = nav.querySelector('[data-motureo-toc-details]');
  const wide = window.matchMedia('(min-width: 1100px)');
  const syncOpen = () => {
    if (details) details.open = wide.matches;
  };
  syncOpen();
  wide.addEventListener('change', syncOpen);

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  nav.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
    target.focus({ preventScroll: true });
    history.replaceState(null, '', link.hash);
  });
})();
